import { Toaster as SonnerToaster, toast } from 'sonner';

import { errorMessage } from '@/shared/services/api/api-error';

/**
 * Les messages éphémères : « Enregistré », « Lien copié », un échec de geste.
 *
 * Une pastille d'encre, en bas au centre sur téléphone (au-dessus de la barre
 * d'onglets), en bas à droite sur ordinateur. Pas d'icône verte ni rouge : la
 * phrase suffit, comme sur Instagram. Un échec qui demande une correction ne
 * passe pas par ici : il se dit sous le bouton qui l'a lancé.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-center"
      offset={{ bottom: 24 }}
      mobileOffset={{ bottom: 'calc(72px + env(safe-area-inset-bottom, 0px))' }}
      gap={8}
      visibleToasts={3}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-full max-w-[420px] items-center gap-3 rounded-md bg-fg px-4 py-3 text-subtle text-bg shadow-floating',
          title: 'text-subtle',
          description: 'text-caption opacity-80',
          actionButton:
            'ml-auto shrink-0 rounded-sm px-2 py-1 text-subtle font-medium text-accent hover:bg-white/10',
          cancelButton: 'shrink-0 text-caption opacity-70',
        },
      }}
    />
  );
}

/** Les trois tons d'un message éphémère : le même habit, le texte change. */
export const notify = {
  success: (message: string) => toast(message),
  info: (message: string) => toast(message),
  error: (error: unknown) => toast(typeof error === 'string' ? error : errorMessage(error)),
  action: (message: string, label: string, onClick: () => void) =>
    toast(message, { action: { label, onClick } }),
};
